const DISPUTE_MAP = {
    types: [
        {label: 'Information Request', value: 'information-request'},
        {label: 'First Chargeback', value: 'first-chargeback'},
        {label: 'Second Chargeback', value: 'second-chargeback'},
        {label: 'Arbitration', value: 'arbitration'},
    ],
    status: [
        {label: 'Response Needed', value: 'response-needed'},
        {label: 'Under Review', value: 'under-review'},
        {label: 'Forfeited', value: 'forfeited'},
        {label: 'Won', value: 'won'},
        {label: 'Lost', value: 'lost'},
        {label: 'Unknown', value: 'unknown'},
    ],
    reasons: [
        {reasonCode: '10.1', description: 'EMV Liability Shift', scheme: 'Visa'},
        {reasonCode: '10.2', description: 'EMV Liability Shift Non-counterfeit Fraud', scheme: 'Visa'},
        {reasonCode: '10.3', description: 'Other Fraud: Card-Present Environment', scheme: 'Visa'},
        {reasonCode: '10.4', description: 'Other Fraud: Card-Absent Environment', scheme: 'Visa'},
        {reasonCode: '10.5', description: 'Visa Fraud Monitoring Program', scheme: 'Visa'},
        {reasonCode: '11.1', description: 'Card Recovery Bulletin', scheme: 'Visa'},
        {reasonCode: '11.2', description: 'Declined Authorisation', scheme: 'Visa'},
        {reasonCode: '11.3', description: 'No Authorisation', scheme: 'Visa'},
        {reasonCode: '12.1', description: 'Late Presentment', scheme: 'Visa'},
        {reasonCode: '12.2', description: 'Incorrect Transaction Code', scheme: 'Visa'},
        {reasonCode: '12.3', description: 'Incorrect Currency', scheme: 'Visa'},
        {reasonCode: '12.4', description: 'Incorrect Account Number', scheme: 'Visa'},
        {reasonCode: '12.5', description: 'Incorrect Amount', scheme: 'Visa'},
        {reasonCode: '12.6', description: 'Duplicate Processing/Paid by Other Means', scheme: 'Visa'},
        {reasonCode: '12.7', description: 'Invalid Data', scheme: 'Visa'},
        {reasonCode: '13.1', description: 'Merchandise/Services Not Received', scheme: 'Visa'},
        {reasonCode: '13.2', description: 'Canceled Recurring Transaction', scheme: 'Visa'},
        {reasonCode: '13.3', description: 'Not as Described or Defective Merchandise/Services', scheme: 'Visa'},
        {reasonCode: '13.4', description: 'Counterfeit Merchandise', scheme: 'Visa'},
        {reasonCode: '13.5', description: 'Misrepresentation', scheme: 'Visa'},
        {reasonCode: '13.6', description: 'Credit Not Processed', scheme: 'Visa'},
        {reasonCode: '13.7', description: 'Canceled Merchandise/Services', scheme: 'Visa'},
        {reasonCode: '13.8', description: 'Original Credit Transaction Not Accepted', scheme: 'Visa'},
        {reasonCode: '13.9', description: 'Non-Receipt of Cash or Load Transaction Value', scheme: 'Visa'},
        {reasonCode: '1000', description: 'Retrieval/Copy Request', scheme: 'MasterCard'},
        {reasonCode: '57', description: 'Credit Card Activated Telephone Transaction', scheme: 'MasterCard'},
        {reasonCode: '12', description: 'Account Number Not on File', scheme: 'MasterCard'},
        {reasonCode: '2', description: 'Requested/Required Information Illegible or Missing', scheme: 'MasterCard'},
        {reasonCode: '31', description: 'Transaction Amount Differs', scheme: 'MasterCard'},
        {reasonCode: '35', description: 'Invalid or Expired Card', scheme: 'MasterCard'},
        {reasonCode: '37', description: 'No Cardholder Authorization', scheme: 'MasterCard'},
        {reasonCode: '40', description: 'Fraudulent Processing of Transactions', scheme: 'MasterCard'},
        {reasonCode: '41', description: 'Canceled Recurring Transaction', scheme: 'MasterCard'},
        {reasonCode: '42', description: 'Late Presentment', scheme: 'MasterCard'},
        {reasonCode: '46', description: 'Correct Currency Code Not Provided', scheme: 'MasterCard'},
        {
            reasonCode: '47',
            description: 'Exceeds Floor Limit, Not Authorized and Fraudulent Transaction',
            scheme: 'MasterCard',
        },
        {reasonCode: '49', description: 'Questionable Merchant Activity', scheme: 'MasterCard'},
        {reasonCode: '50', description: 'Credit Posted as a Purchase', scheme: 'MasterCard'},
        {reasonCode: '53', description: 'Not As Described or Defective Merchandise', scheme: 'MasterCard'},
        {reasonCode: '54', description: 'Cardholder Dispute - Not Elsewhere classified', scheme: 'MasterCard'},
        {reasonCode: '55', description: 'Non-Receipt of Merchandise', scheme: 'MasterCard'},
        {reasonCode: '59', description: 'Services Not Rendered or Paid by Other Means', scheme: 'MasterCard'},
        {reasonCode: '60', description: 'Credit Not Processed', scheme: 'MasterCard'},
        {reasonCode: '7', description: 'Warning Bulletin File', scheme: 'MasterCard'},
        {reasonCode: '8', description: 'Requested/required Authorization Not Obtained', scheme: 'MasterCard'},
        {reasonCode: '00', description: 'Other', scheme: 'MasterCard'},
        {reasonCode: '63', description: 'Cardholder Does Not Recognize - Potential Fraud', scheme: 'MasterCard'},
        {reasonCode: 'A01', description: 'Charge Amount Exceeds Authorization Amount', scheme: 'American Express'},
        {reasonCode: 'A02', description: 'No Valid Authorization', scheme: 'American Express'},
        {reasonCode: 'A08', description: 'Authorization Approval Expired', scheme: 'American Express'},
        {reasonCode: 'F10', description: 'Missing Imprint', scheme: 'American Express'},
        {reasonCode: 'F14', description: 'Missing Signature', scheme: 'American Express'},
        {reasonCode: 'F22', description: 'Expired or Not Yet Valid Card', scheme: 'American Express'},
        {reasonCode: 'F24', description: 'No Card Member Authorization', scheme: 'American Express'},
        {reasonCode: 'F29', description: 'Card Not Present', scheme: 'American Express'},
        {reasonCode: 'C02', description: 'Credit (or partial credit) Not Processed', scheme: 'American Express'},
        {reasonCode: 'C04', description: 'Goods/Services Returned or Refused', scheme: 'American Express'},
        {reasonCode: 'C05', description: 'Goods/Services Canceled', scheme: 'American Express'},
        {reasonCode: 'C08', description: 'Goods/Services Not Received', scheme: 'American Express'},
        {reasonCode: 'C14', description: 'Paid by Other Means', scheme: 'American Express'},
        {reasonCode: 'C18', description: '“No Show” or CARDeposit Canceled', scheme: 'American Express'},
        {reasonCode: 'C28', description: 'Canceled Recurring Billing', scheme: 'American Express'},
        {reasonCode: 'C31', description: 'Goods/Services Not as Described', scheme: 'American Express'},
        {reasonCode: 'C32', description: 'Goods/Services Damaged or Defective', scheme: 'American Express'},
        {reasonCode: 'M10', description: 'Vehicle Rental – Capital Damages', scheme: 'American Express'},
        {reasonCode: 'M49', description: 'Vehicle Rental – Theft or Loss of Use', scheme: 'American Express'},
        {reasonCode: 'P01', description: 'Unassigned Card Number', scheme: 'American Express'},
        {reasonCode: 'P03', description: 'Credit Processed as Charge', scheme: 'American Express'},
        {reasonCode: 'P04', description: 'Charge Processed as Credit', scheme: 'American Express'},
        {reasonCode: 'P05', description: 'Incorrect Charge Amount', scheme: 'American Express'},
        {reasonCode: 'P07', description: 'Late Submission', scheme: 'American Express'},
        {reasonCode: 'P08', description: 'Duplicate Charge', scheme: 'American Express'},
        {reasonCode: 'P22', description: 'Nonmatching Card Number', scheme: 'American Express'},
        {reasonCode: 'P23', description: 'Currency Discrepancy', scheme: 'American Express'},
        {reasonCode: 'R03', description: 'Insufficient Reply', scheme: 'American Express'},
        {reasonCode: 'R13', description: 'No Reply', scheme: 'American Express'},
        {reasonCode: 'M01', description: 'Chargeback Authorization', scheme: 'American Express'},
        {reasonCode: 'FR1', description: 'Fraud Full Recourse Program', scheme: 'American Express'},
        {reasonCode: 'FR4', description: 'Immediate Chargeback Program', scheme: 'American Express'},
        {reasonCode: 'FR6', description: 'Partial Immediate Chargeback Program', scheme: 'American Express'},
        {reasonCode: 'AL', description: 'Airline Transaction Dispute', scheme: 'Discover'},
        {reasonCode: 'AP', description: 'Automatic Payment', scheme: 'Discover'},
        {reasonCode: 'AW', description: 'Altered Amount', scheme: 'Discover'},
        {reasonCode: 'CA', description: 'Cash Advance Dispute', scheme: 'Discover'},
        {reasonCode: 'CD', description: 'Credit Posted as Card Sale', scheme: 'Discover'},
        {reasonCode: 'CR', description: 'Canceled Reservation', scheme: 'Discover'},
        {reasonCode: 'DA', description: 'Declined Authorization', scheme: 'Discover'},
        {reasonCode: 'DP', description: 'Duplicate Processing', scheme: 'Discover'},
        {reasonCode: 'DP1', description: 'TM Duplicate Processing', scheme: 'Discover'},
        {reasonCode: 'EX', description: 'Expired Card', scheme: 'Discover'},
        {reasonCode: 'IC', description: 'Illegible Sales Data', scheme: 'Discover'},
        {reasonCode: 'IN', description: 'Invalid Card Number', scheme: 'Discover'},
        {reasonCode: 'IS', description: 'Missing Signature', scheme: 'Discover'},
        {reasonCode: 'LP', description: 'Late Presentment', scheme: 'Discover'},
        {reasonCode: 'N', description: 'Discover Network ATM Transaction – No Funds Dispensed', scheme: 'Discover'},
        {reasonCode: 'NA', description: 'No Authorization', scheme: 'Discover'},
        {reasonCode: 'NC', description: 'Not Classified', scheme: 'Discover'},
        {
            reasonCode: 'P',
            description: 'Discover Network ATM Transaction – Partial Funds Dispensed',
            scheme: 'Discover',
        },
        {reasonCode: 'RG', description: 'Non-Receipt of Goods or Services', scheme: 'Discover'},
        {reasonCode: 'RM', description: 'Cardholder Disputes Quality of Goods or Services', scheme: 'Discover'},
        {reasonCode: 'RN1', description: 'Additional Credit Requested', scheme: 'Discover'},
        {reasonCode: 'RN2', description: 'Credit Not Received', scheme: 'Discover'},
        {reasonCode: 'SV', description: 'Stored Value Dispute', scheme: 'Discover'},
        {
            reasonCode: 'TF',
            description: 'Dispute Initiated by Discover Network for Violation of Operating Regulations',
            scheme: 'Discover',
        },
        {
            reasonCode: 'TNM',
            description: 'Discover Network ATM Transaction - Transaction Improperly Posted to Cardholder’s Account',
            scheme: 'Discover',
        },
        {reasonCode: 'UA01', description: 'No Authorization', scheme: 'Discover'},
        {reasonCode: 'UA02', description: 'Declined Authorization', scheme: 'Discover'},
        {
            reasonCode: 'UA32',
            description: 'Address Verification Service Failure; Card Not Present Card Transaction',
            scheme: 'Discover',
        },
        {reasonCode: 'UA99', description: 'Non-Compliance with Operating Regulations', scheme: 'Discover'},
        {reasonCode: 'UA03', description: 'Sale Exceeds Authorization Amount', scheme: 'Discover'},
        {
            reasonCode: 'UA10',
            description: 'Request Transaction Receipt for Swiped Card Transaction',
            scheme: 'Discover',
        },
        {reasonCode: 'UA11', description: 'Swiped Card Transaction – No Signature', scheme: 'Discover'},
        {reasonCode: 'UA12', description: 'Swiped Card Transaction – Invalid Signature', scheme: 'Discover'},
        {reasonCode: 'UA18', description: 'Swiped Card Transaction – Illegible Copy', scheme: 'Discover'},
        {
            reasonCode: 'UA20',
            description: 'Request Transaction Documentation for Keyed Card Transaction',
            scheme: 'Discover',
        },
        {reasonCode: 'UA21', description: 'Keyed Card Transaction – No Signature', scheme: 'Discover'},
        {reasonCode: 'UA22', description: 'Keyed Card Transaction – Invalid Signature', scheme: 'Discover'},
        {reasonCode: 'UA23', description: 'Keyed Card Transaction – Invalid Imprint', scheme: 'Discover'},
        {reasonCode: 'UA28', description: 'Keyed Card Transaction – Illegible Copy', scheme: 'Discover'},
        {
            reasonCode: 'UA30',
            description: 'Request Transaction Document for Card Not Present Transactions',
            scheme: 'Discover',
        },
        {
            reasonCode: 'UA31',
            description: 'Card Not Present Card Transaction – Invalid Proof of Delivery',
            scheme: 'Discover',
        },
        {reasonCode: 'UA38', description: 'Card Not Present Card Transaction – illegible Copy', scheme: 'Discover'},
        {reasonCode: 's1', description: 'Duplicate', scheme: 'Stripe'},
        {reasonCode: 's2', description: 'Fraudulent', scheme: 'Stripe'},
        {reasonCode: 's3', description: 'Subscription Canceled', scheme: 'Stripe'},
        {reasonCode: 's4', description: 'Product Unacceptable', scheme: 'Stripe'},
        {reasonCode: 's5', description: 'Product Not Received', scheme: 'Stripe'},
        {reasonCode: 's6', description: 'Unrecognized', scheme: 'Stripe'},
        {reasonCode: 's7', description: 'Credit Not Processed', scheme: 'Stripe'},
        {reasonCode: 's8', description: 'Goods Services Returned Or Refused', scheme: 'Stripe'},
        {reasonCode: 's9', description: 'Goods Services Canceled', scheme: 'Stripe'},
        {reasonCode: 's10', description: 'Incorrect Account Details', scheme: 'Stripe'},
        {reasonCode: 's11', description: 'Insufficient Funds', scheme: 'Stripe'},
        {reasonCode: 's12', description: 'Bank Cannot Process', scheme: 'Stripe'},
        {reasonCode: 's13', description: 'Debit Not Authorized', scheme: 'Stripe'},
        {reasonCode: 's14', description: 'General', scheme: 'Stripe'},
    ],
};

export default DISPUTE_MAP;
